import type { ManualEntryCategory } from "../types/manualEntry";

/** 八类人工费用的固定显示顺序。 */
export const MANUAL_ENTRY_CATEGORIES: ReadonlyArray<{ key: ManualEntryCategory; label: string }> = [
  { key: "stay", label: "住宿" }, { key: "air", label: "飞机" }, { key: "ship", label: "船" }, { key: "bus", label: "大巴车" },
  { key: "point", label: "门票" }, { key: "meal", label: "餐" }, { key: "crew", label: "司导" }, { key: "misc", label: "杂费" },
];
/** 餐别快捷项顺序固定；参考餐数由真实区域提供。 */
export const MANUAL_MEAL_TYPES = ["正餐", "早餐", "中餐", "晚餐"] as const;
/** 司导快捷项只维护项目、角色和默认单位，不推导价格。 */
export const MANUAL_CREW_ITEMS = [
  { name: "导服费", role: "导游", unit: "天" }, { name: "导游电话费", role: "导游", unit: "人" },
  { name: "老师餐补", role: "老师", unit: "天" }, { name: "司机餐补", role: "司机", unit: "天" },
  { name: "导游餐补", role: "导游", unit: "天" }, { name: "导游路补", role: "导游", unit: "天" },
  { name: "导游大交通", role: "导游", unit: "次" }, { name: "导游查房补", role: "导游", unit: "天" },
  { name: "导游住宿", role: "导游", unit: "晚" }, { name: "司陪住宿", role: "司陪", unit: "晚" },
] as const;
/** 杂费快捷项保留名称顺序和原有默认人数口径。 */
export const MANUAL_MISC_ITEMS = [
  { name: "单房差", role: null }, { name: "开票税金", role: null }, { name: "横幅", role: null },
  { name: "快递费", role: null }, { name: "电话费", role: null }, { name: "蜀地资金池", role: "学生" },
  { name: "领队打车", role: null }, { name: "保险", role: "学生" }, { name: "导游资金池", role: "学生" },
  { name: "运营费", role: "学生" }, { name: "企业资金池", role: "学生" }, { name: "非遗资金池", role: "学生" },
] as const;
